import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, HostBinding, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { MatDialog, MatSnackBar } from '@angular/material';
import { CurrentService, IsDuplicatePKError } from 'dbweb-core';
import { Subscription } from 'rxjs';
import { ConfirmDialogComponent } from '../../components/confirm-dialog/confirm-dialog.component';
import { ViewDefineComponent } from '../../components/view-define/view-define.component';
import { ServiceService } from '../service/service.service';
import { OwnerByEnum } from '../../services/eleview/types/model';

@Component({
	selector: 'common-view-drawer',
	templateUrl: './view-drawer.component.html',
	styleUrls: ['./view-drawer.component.scss']
})
export class ViewDrawerComponent implements OnInit, OnDestroy {
	readonly ownerByUser = OwnerByEnum.ownerByUser;
	readonly ownerByDept = OwnerByEnum.ownerByDept;
	@ViewChild('viewDefine', { static: true, read: ViewDefineComponent }) viewDefine: ViewDefineComponent;
	@HostBinding('class.view-drawer') hostClass = true;
	@Output() close = new EventEmitter();
	subscribes: Subscription[] = [];

	constructor(
		public svr: ServiceService,
		public curr: CurrentService,
		private dialog: MatDialog,
		private snackBar: MatSnackBar
	) {}

	ngOnInit() {
		// this.subscribes.push(
		// 	this.svr.editView.currentChange.subscribe(
		// 		() => (this.viewDefine.SelectedColumns = this.svr.editView.SelectedColumns)
		// 	)
		// );
	}
	ngOnDestroy() {
		this.subscribes.forEach(v => v.unsubscribe());
	}
	canModify(): boolean {
		return (
			!this.svr.editView.titleInput &&
			this.svr.editView.current &&
			this.svr.editView.current.canModify(this.curr.data.UserName, this.curr.data.Dept.Code)
		);
	}
	ok() {
		const process = () => {
			this.svr.data.selectedView = this.svr.editView.current;
			this.svr.refreshData().subscribe(v => {
				if (v.ok) {
					this.close.emit();
				} else {
					this.snackBar.open(v.error, 'ç¡®å®', { duration: 5000 });
				}
			});
		};
		if (this.svr.editView.modify) {
			this.svr.editView.save().subscribe(() => {
				process();
			});
		} else {
			process();
		}
	}

	remove() {
		const dialogRef = this.dialog.open(ConfirmDialogComponent, {
			width: '360px',
			height: '184px',
			data: 'ç¡®å®è¦å é¤è§å¾[' + this.svr.editView.current.Name + '] å?',
			autoFocus: false
		});

		dialogRef.afterClosed().subscribe((result: boolean) => {
			if (result) {
				this.svr.editView.remove();
			}
		});
	}
	editDone() {
		this.svr.editView.done().subscribe(
			() => {},
			(err: HttpErrorResponse) => {
				const derr = IsDuplicatePKError(err.error);
				if (derr.Yes) {
					this.snackBar.open('åç§°éå¤', 'ç¡®å®', { duration: 5000 });
				} else {
					this.snackBar.open(err.error, 'ç¡®å®', { duration: 5000 });
				}
			}
		);
	}
}
